export const constructDOBLink = (bbl, bin = undefined) => {
  const baseLink = 'http://a810-bisweb.nyc.gov/bisweb/PropertyProfileOverviewServlet'
  if (bin) {
    return `${baseLink}?bin=${bin}&requestid=1`
  } else {
    return `${baseLink}?boro=${bbl.charAt(0)}&block=${bbl.slice(1, 6)}&lot=${bbl.slice(6, 10)}`
  }
}

export const constructDOBCOLink = bin =>
  `http://a810-bisweb.nyc.gov/bisweb/COsByLocationServlet?requestid=2&allbin=${bin}`

export const constructFinancePTSLink = (bbl, mode = 'profileall2') =>
  `https://a836-pts-access.nyc.gov/care/datalets/datalet.aspx?mode=${mode}&UseSearch=no&pin=${bbl}`
